//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Importeert bepaalde content in adviesbox
     * @param koppelingKey (optional) 
     * @param body (optional) 
     * @return Success
     */
    zet_een_content_klaar_voor_import(koppelingKey: string | null | undefined, body: ImportTaakRequest | null | undefined): Promise<ImportStatusOutput> {
        let url_ = this.baseUrl + "/ImportTaak";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "koppelingKey": koppelingKey !== undefined && koppelingKey !== null ? "" + koppelingKey : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processZet_een_content_klaar_voor_import(_response);
        });
    }

    protected processZet_een_content_klaar_voor_import(response: Response): Promise<ImportStatusOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportStatusOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportStatusOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportStatusOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportStatusOutput>(null as any);
    }

    /**
     * Verkrijgen van Base64 inhoud van een HBX (voor testdoeleinden)
     * @param file (optional) 
     * @return Success
     */
    verkrijgen_van_Base64_inhoud_van_een_hbx(file: FileParameter | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/ImportTaak/Hbx/GetBase64";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerkrijgen_van_Base64_inhoud_van_een_hbx(_response);
        });
    }

    protected processVerkrijgen_van_Base64_inhoud_van_een_hbx(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Importeert bepaalde content in adviesbox
     * @param koppelingKey (optional) 
     * @return Success
     */
    geeft_de_huidige_status_van_een_importTaak(koppelingKey: string | null | undefined, importTaakId: string): Promise<ImportStatusOutput> {
        let url_ = this.baseUrl + "/ImportTaak/{importTaakId}/status";
        if (importTaakId === undefined || importTaakId === null)
            throw new Error("The parameter 'importTaakId' must be defined.");
        url_ = url_.replace("{importTaakId}", encodeURIComponent("" + importTaakId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "koppelingKey": koppelingKey !== undefined && koppelingKey !== null ? "" + koppelingKey : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeeft_de_huidige_status_van_een_importTaak(_response);
        });
    }

    protected processGeeft_de_huidige_status_van_een_importTaak(response: Response): Promise<ImportStatusOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportStatusOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportStatusOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportStatusOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportStatusOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportStatusOutput>(null as any);
    }

    /**
     * Geeft een lijst aan opgeslagen importtaken
     * @param koppelingKey (optional) 
     * @param status (optional) 
     * @return Success
     */
    geeft_een_lijst_aan_opgeslagen_importtaken(vestigingId: string, koppelingKey: string | null | undefined, status: string | null | undefined): Promise<ImportTakenOutput> {
        let url_ = this.baseUrl + "/importTaken?";
        if (koppelingKey !== undefined && koppelingKey !== null)
            url_ += "koppelingKey=" + encodeURIComponent("" + koppelingKey) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeeft_een_lijst_aan_opgeslagen_importtaken(_response);
        });
    }

    protected processGeeft_een_lijst_aan_opgeslagen_importtaken(response: Response): Promise<ImportTakenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportTakenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportTakenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportTakenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportTakenOutput>(null as any);
    }

    /**
     * Geeft een volledige opgeslagen importTaak
     * @return Success
     */
    geeft_volledige_importtaak(vestigingId: string, koppelingKey: string, importTaakId: string): Promise<ImportTaakOutput> {
        let url_ = this.baseUrl + "/importTaak/{koppelingKey}/{importTaakId}";
        if (koppelingKey === undefined || koppelingKey === null)
            throw new Error("The parameter 'koppelingKey' must be defined.");
        url_ = url_.replace("{koppelingKey}", encodeURIComponent("" + koppelingKey));
        if (importTaakId === undefined || importTaakId === null)
            throw new Error("The parameter 'importTaakId' must be defined.");
        url_ = url_.replace("{importTaakId}", encodeURIComponent("" + importTaakId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeeft_volledige_importtaak(_response);
        });
    }

    protected processGeeft_volledige_importtaak(response: Response): Promise<ImportTaakOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportTaakOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportTaakOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportTaakOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportTaakOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportTaakOutput>(null as any);
    }

    /**
     * Zet de status van een importtaak
     * @param body (optional) 
     * @return Created
     */
    zet_de_huidige_status_van_een_importTaak_naar_confirm(vestigingId: string, koppelingKey: string, importTaakId: string, body: ImportConfirmInput | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/importTaak/{importTaakId}/confirm";
        if (importTaakId === undefined || importTaakId === null)
            throw new Error("The parameter 'importTaakId' must be defined.");
        url_ = url_.replace("{importTaakId}", encodeURIComponent("" + importTaakId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "koppelingKey": koppelingKey !== undefined && koppelingKey !== null ? "" + koppelingKey : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processZet_de_huidige_status_van_een_importTaak_naar_confirm(_response);
        });
    }

    protected processZet_de_huidige_status_van_een_importTaak_naar_confirm(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * maakt aanpassingen in een importtaak en doet een confirm na de patch
     * @param body (optional) 
     * @return Success
     */
    maak_aanpassingen_op_een_bestaande_import_en_confirm_na_de_patch(vestigingId: string, koppelingKey: string, importTaakId: string, body: ImportPatchInput | null | undefined): Promise<PatchOutput> {
        let url_ = this.baseUrl + "/importTaak/{importTaakId}/confirm";
        if (importTaakId === undefined || importTaakId === null)
            throw new Error("The parameter 'importTaakId' must be defined.");
        url_ = url_.replace("{importTaakId}", encodeURIComponent("" + importTaakId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "koppelingKey": koppelingKey !== undefined && koppelingKey !== null ? "" + koppelingKey : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMaak_aanpassingen_op_een_bestaande_import_en_confirm_na_de_patch(_response);
        });
    }

    protected processMaak_aanpassingen_op_een_bestaande_import_en_confirm_na_de_patch(response: Response): Promise<PatchOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PatchOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PatchOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PatchOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatchOutput>(null as any);
    }

    /**
     * Zet de status van een importtaak
     * @return No Content
     */
    zet_de_huidige_status_van_een_importTaak_naar_reject(vestigingId: string, koppelingKey: string, importTaakId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/importTaak/{importTaakId}/reject";
        if (importTaakId === undefined || importTaakId === null)
            throw new Error("The parameter 'importTaakId' must be defined.");
        url_ = url_.replace("{importTaakId}", encodeURIComponent("" + importTaakId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "koppelingKey": koppelingKey !== undefined && koppelingKey !== null ? "" + koppelingKey : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processZet_de_huidige_status_van_een_importTaak_naar_reject(_response);
        });
    }

    protected processZet_de_huidige_status_van_een_importTaak_naar_reject(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * maakt aanpassingen in een importtaak
     * @param body (optional) 
     * @return Success
     */
    maak_aanpassingen_op_een_bestaande_import(vestigingId: string, koppelingKey: string, importTaakId: string, body: ImportPatchInput | null | undefined): Promise<PatchOutput> {
        let url_ = this.baseUrl + "/importTaak/{importTaakId}";
        if (importTaakId === undefined || importTaakId === null)
            throw new Error("The parameter 'importTaakId' must be defined.");
        url_ = url_.replace("{importTaakId}", encodeURIComponent("" + importTaakId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "koppelingKey": koppelingKey !== undefined && koppelingKey !== null ? "" + koppelingKey : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMaak_aanpassingen_op_een_bestaande_import(_response);
        });
    }

    protected processMaak_aanpassingen_op_een_bestaande_import(response: Response): Promise<PatchOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PatchOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PatchOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PatchOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatchOutput>(null as any);
    }

    /**
     * @return Success
     */
    getVersionInfo(): Promise<VersionInfo> {
        let url_ = this.baseUrl + "/VersionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVersionInfo(_response);
        });
    }

    protected processGetVersionInfo(response: Response): Promise<VersionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BadRequestResult;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VersionInfo>(null as any);
    }

    /**
     * @return Success
     */
    getFoutcodes(): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/VersionInfo/FoutCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFoutcodes(_response);
        });
    }

    protected processGetFoutcodes(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }
}

export interface BadRequestResult {
    statusCode: number;
}

/** ContentTypeOptions Klantdossier = 0, AboxNawV1Json = 1, AboxV1Json = 2, AboxV1File = 3, HbxV1File = 4, Test = 5 */
export enum ContentTypeOptions {
    Klantdossier = "Klantdossier",
    AboxNawV1Json = "AboxNawV1Json",
    AboxV1Json = "AboxV1Json",
    AboxV1File = "AboxV1File",
    HbxV1File = "HbxV1File",
    Test = "Test",
}

/** Import confirm input */
export interface ImportConfirmInput {
    /** CorrelationId */
    correlationId: string | null;
}

/** Import Patch input */
export interface ImportPatchInput {
    /** CorrelationId */
    correlationId: string | null;
    /** Patches */
    patchData: Operation[] | null;
}

/** Import output */
export interface ImportStatusOutput {
    /** Id van de ImportTaak */
    importTaakId: string;
    status: StatusOptions;
    /** Datum dat de taak origineel is aangemaakt */
    aanmaakDatum: string;
    /** De importdatum */
    importDatum: string | null;
    /** Validatiefouten */
    validationErrors: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface ImportTaak {
    importTaakId: string;
    koppelingKey: string;
    koppelingNaam: string | null;
    aanmaakDatum: string;
    gebruiker: string | null;
    vorigImportTaakId: string | null;
    contentType: ContentTypeOptions;
    content: string;
    onStatusChangeCallback: string | null;
    status: StatusOptions;
    convertedContentType: ContentTypeOptions | null;
    convertedContent: string | null;
    klantdossierId: string | null;
    adviesdossierId: string | null;
    klantnaam: string | null;
    importDatum: string | null;
    validationErrors: string | null;
    executionErrors: string | null;
}

/** Overzicht importtaken */
export interface ImportTaakOutput {
    importTaak: ImportTaak | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Input voor een importTaak. */
export interface ImportTaakRequest {
    /** De email van de gebruiker. */
    gebruiker: string | null;
    /** Het Id van de vorige importTaak. */
    vorigImportTaakId: string | null;
    /** Het contenttype van de importTaak. */
    contentType: string | null;
    /** De inhoud van de importTaak. */
    content: string | null;
    /** Url om statuschange op terug te sturen */
    onStatusChangeCallback: string | null;
}

/** Overzicht importtaak */
export interface ImportTaakSamenvatting {
    /** Id van de importTaak */
    importTaakId: string;
    /** De KoppelingKey */
    koppelingKey: string | null;
    /** Naam van de koppeling */
    koppelingNaam: string | null;
    /** Gebruiker die de importTaak heeft aangemaakt */
    gebruiker: string | null;
    contentType: ContentTypeOptions;
    status: StatusOptions;
    convertedContentType: ContentTypeOptions | null;
    /** Het id van het klantdossier */
    klantDossierId: string | null;
    /** De naam van de klant */
    klantnaam: string | null;
    /** De importdatum */
    aanmaakDatum: string;
    /** De importdatum */
    importDatum: string | null;
}

/** Overzicht importtaken */
export interface ImportTakenOutput {
    /** Importtaken */
    importTaken: ImportTaakSamenvatting[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface NewOutput {
    id: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface Operation {
    value: any | null;
    path: string | null;
    op: string | null;
    from: string | null;
}

/** Import output */
export interface PatchOutput {
    /** Id van de ImportTaak */
    correlationId: string;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** StatusOptions New = 0, Ready = 1, Rejected = 2, Confirmed = 3, Success = 4, ExecutionError = 5, ValidationError = 6 */
export enum StatusOptions {
    New = "New",
    Ready = "Ready",
    Rejected = "Rejected",
    Confirmed = "Confirmed",
    Success = "Success",
    ExecutionError = "ExecutionError",
    ValidationError = "ValidationError",
}

export interface ValidationResultModel {
    code: string | null;
    target: string | null;
    message: string | null;
}

export interface ValidationResultsModel {
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface VersionInfo {
    naam: string | null;
    versie: string | null;
    auteur: string | null;
    copyright: string | null;
    opstartDatumTijd: string | null;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}